import React from "react";

interface ConfirmDialogProps {
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
  singleButton?: boolean;
}

export default function ConfirmDialog({
  message,
  onConfirm,
  onCancel,
  singleButton = false,
}: ConfirmDialogProps) {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50 px-6">
      
      <div className="bg-[#2C2C2E] rounded-3xl shadow-2xl p-6 w-full max-w-sm">
        
        {/* Title */}
        <h2 className="text-[17px] font-semibold text-white mb-2">
          Report Failed
        </h2>

        {/* Message */}
        <p className="text-[14px] text-gray-400 mb-6 leading-relaxed">
          {message}
        </p>

        {/* Buttons */}
        <div className={`flex gap-3 ${singleButton ? "justify-center" : "justify-between"}`}>
          
          {!singleButton && onCancel && (
            <button
              className="flex-1 bg-[#3A3A3C] text-white py-3 rounded-2xl text-[15px]"
              onClick={onCancel}
            >
              Cancel
            </button>
          )}

          <button
            className={`${
              singleButton
                ? "w-full bg-[#3A3A3C]"
                : "flex-1 bg-[#0A84FF]"
            } text-white py-3 rounded-2xl text-[15px]`}
            onClick={onConfirm}
          >
            {singleButton ? "OK" : "Yes"}
          </button>
        </div>
      </div>
    </div>
  );
}
